import { useQuery } from '@tanstack/react-query';
import { Inbox } from 'lucide-react';
import { Section, TimesheetCards } from '../../components/TimesheetCards';
import { Card, EmptyState, PageHeader } from '../../components/ui';
import { api } from '../../lib/api';
import { useSetCrumbs } from '../../lib/crumbs';

/** Список табелей для кадров: «Завершён» и «Подписан» (FR-024). */
export function HrList() {
  useSetCrumbs([{ label: 'На проверку' }]);
  const list = useQuery({ queryKey: ['timesheets', 'hr'], queryFn: api.list });
  const items = list.data ?? [];
  const waiting = items.filter((t) => t.status === 'completed');
  const signed = items.filter((t) => t.status === 'signed');
  return (
    <>
      <PageHeader
        title="На проверку"
        description="Табели, которые бригадиры завершили. Проверьте часы, затем подпишите или верните с комментарием."
      />
      {list.isLoading ? (
        <p className="text-[13px] text-ink-3">Загрузка…</p>
      ) : items.length === 0 ? (
        <Card>
          <EmptyState
            icon={Inbox}
            title="Табелей на проверку нет"
            description="Здесь появятся табели, когда бригадир нажмёт «Завершить»."
          />
        </Card>
      ) : (
        <>
          <Section title="Ждут подписи" count={waiting.length}>
            {waiting.length > 0 ? (
              <TimesheetCards items={waiting} />
            ) : (
              <p className="text-[13px] text-ink-3">Все завершённые табели подписаны.</p>
            )}
          </Section>
          {signed.length > 0 && (
            <Section title="Подписаны" count={signed.length}>
              <TimesheetCards items={signed} />
            </Section>
          )}
        </>
      )}
    </>
  );
}
